import { TableHeaderType } from '../../../common';

export const usersListMap: TableHeaderType[] = [
	{
		label: 'ID',
		key: 'user_id',
	},
	{
		label: 'Username',
		key: 'username',
	},
	{
		label: 'Email',
		key: 'email',
	},
	{
		label: 'Role',
		key: 'roles',
	},
];
